import { Constants } from "../constants";

// actions
export const setDataForm = (payload: any) => ({
    type: Constants.SET_DATA_FORM,
    payload: payload
});